import {googleMapsKey} from '../constants';
import $ from 'jquery';
import _ from 'underscore';
import Helper from 'helpers/util';
//import balanceText from 'libs/BalanceText';

// Analytics loaded check
function checkIfAnalyticsLoaded() {
	if ( window.ga ) {
		// Do tracking with new-style analytics
		Helper.pubsub.publish('googleAnalyticsLoaded');
	} else {
		// Retry
		setTimeout(()=>{
			checkIfAnalyticsLoaded();
		},200);
	}
}
checkIfAnalyticsLoaded();

// Function to check if site is currrently in responsive mobile mode (xs breakpoint)
window.isMobileMode = () => {
	let mobileJsCheckEl = document.getElementById('mobile-js-check');
	if ( window.getComputedStyle(mobileJsCheckEl).position === 'absolute' ) {
		return true;
	} else {
		return false;
	}
}

// Google Maps API script include
window.googleMapsLoaded = () => {
	Helper.pubsub.publish('googleMapsLoaded');
};
let gMapsJs = document.createElement('script');
gMapsJs.type = 'text/javascript';
gMapsJs.async = true;
gMapsJs.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=places,geometry&callback=window.googleMapsLoaded`;
document.body.appendChild(gMapsJs);

//requestAnimFrame coverall
window.requestAnimFrame = (function() {
	return window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function(callback) {
			window.setTimeout(callback, 1000 / 60);
		};
})();

// Resize event for mobile and desktop
let resizeLayout;
if (window.Modernizr.touch) {
	resizeLayout = () => {
		Helper.pubsub.publish('onWindowResize');
	};
} else {
	resizeLayout = _.debounce(() => {
		Helper.pubsub.publish('onWindowResize');
	}, 100);
}
$(window).on({
	resize: () => {
		if (!window.Modernizr.touch) {
			resizeLayout();
		}
	},
	orientationchange: resizeLayout
});

//text balance for underline headings
// $(document).ready(function() {
// 	balanceText($('.h-underline'),  {
// 		watch: true
// 	});
// });

function getInternetExplorerVersion() {
	var rv = -1;
	if (navigator.appName === 'Microsoft Internet Explorer') {
		let ua = navigator.userAgent;
		let re = new RegExp('MSIE ([0-9]{1,}[0-9]{0,})');
		if (re.exec(ua) !== null) {
			rv = parseFloat(RegExp.$1);
		}
	} else if (navigator.appName === 'Netscape') {
		let ua = navigator.userAgent;
		let re = new RegExp('Trident/.*rv:([0-9]{1,}[0-9]{0,})');
		if (re.exec(ua) !== null) {
			rv = parseFloat(RegExp.$1);
		}
	}
	return rv;
}
if ( getInternetExplorerVersion() > -1 ) {
	//is an ie browser so render ie class to html
	$('html').addClass( 'IE-' + getInternetExplorerVersion() );
}



// Hide splash preloader on load
$(document).ready( () => {

	// sub nav/carousel scroll to active link
	const $activeSubLink = $('.carousel-item.active');
	$activeSubLink.each(function(){
		const parentScroller = $(this).parents('.carousel-inner');
		const scrollContainerWidth = parentScroller.children().width();
		if ( $(this).offset().left > scrollContainerWidth ) {
			parentScroller.scrollLeft(  $(this).offset().left - scrollContainerWidth );
		}
	});

	$('.preloader').fadeOut();
});
